import { createSelector } from 'reselect'
import { NETWORK_DOMAIN, NETWORK_KEY } from 'modules/training/modules/network/constants'

function isConnectedNetworkSelector () {
  return createSelector(
    state => state[NETWORK_DOMAIN],
    domain => domain[NETWORK_KEY.IS_CONNECTED]
  )
}

export default isConnectedNetworkSelector
